<template>
  <Base
    :icon="requirement.negative ? 'mdi-map-marker-off' : 'mdi-map-marker'"
    :satisfied="requirement.satisfied"
    tooltip
  >
    <span>
      {{ requirement.negative ? 'Without' : 'Within' }}
      {{ requirement.value }}
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }}
      {{ requirement.negative ? 'not be within' : 'be within' }}
      {{ requirement.value }}
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
}
</script>
